<template>
    <th class="checkbox">
        <input type="checkbox" v-model="allChecked" :indeterminate.prop="indeterminate" :disabled="disabled" />
    </th>
</template>
<script>
// TODO: this is naive and loses selection from page to page

export default {
    name: 'CheckboxColumn',
    model: {
        prop: 'checkedRows',
        event: 'update:checkedRows',
    },
    props: {
        checkedRows: {
            type: Array,
        },
        rowDisabled: {
            type: Function,
            default: row => {
                return false
            },
        },
    },
    inject: ['table'],

    mounted() {
        this.table.updateColumns()
    },
    beforeDestroy() {
        this.table.updateColumns()
    },
    computed: {
        allChecked: {
            get() {
                return (
                    this.currentPageRows.length > 0 &&
                    this.currentPageRows.length === this.currentPageCheckedRows.length
                )
            },
            set(checked) {
                const rows = checked ? this.currentPageRows.filter(row => !this.rowDisabled(row)) : []
                const otherRows = this.checkedRows.filter(row => !this.currentPageRows.includes(row))

                this.$emit('update:checkedRows', otherRows.concat(rows))
            },
        },
        disabled() {
            return this.currentPageRows.every(row => this.rowDisabled(row))
        },
        indeterminate() {
            return !this.allChecked && this.currentPageCheckedRows.length > 0
        },
        currentPage() {
            return this.table?.page ?? 0
        },
        currentPageRows() {
            return this.table?.rows ?? []
        },
        currentPageCheckedRows() {
            return this.checkedRows.filter(row => this.currentPageRows.includes(row))
        },
        totalRowCount() {
            return this.table?.totalCount ?? 0
        },
    },
    methods: {
        renderTableCell(row) {
            const h = this.$createElement

            let checked = this.checkedRows.indexOf(row) > -1
            let disabled = this.rowDisabled(row)

            return h(
                'td',
                {
                    class: 'checkbox',
                    on: {
                        click: function (event) {
                            event.stopPropagation()

                            // redirect clicks to the checkbox
                            if (event.target == event.currentTarget) {
                                event.currentTarget.querySelector('input').click()
                            }
                        },
                        dblclick: event => event.stopPropagation(),
                    },
                },
                [
                    h('input', {
                        attrs: { type: 'checkbox' },
                        domProps: { checked: checked, disabled },
                        on: { input: event => this.rowChecked(event, row) },
                    }),
                ]
            )
        },
        rowChecked(event, row) {
            const checked = event.target.checked

            // we want this to be driven by the model
            // not by what the browser wants to do
            event.target.checked = !event.target.checked

            let rows = this.checkedRows.slice(0)

            if (checked) {
                rows.push(row)
            } else {
                let i = rows.indexOf(row)
                rows.splice(i, 1)
            }

            this.$emit('update:checkedRows', rows)
        },
    },
}
</script>

<style>
.mt-table {
    td.checkbox,
    th.checkbox {
        border-right: none;
        padding-right: 0;
        width: 32px;

        input::before {
            top: -10px;
        }

        & + td {
            padding-left: 8px;
        }
    }

    th.checkbox > div {
        overflow: visible;
    }
}
</style>
